document.addEventListener('turbo:load', () => {
  document
    .querySelectorAll('[data-submit-on-change]')
    .forEach(el =>
      el.addEventListener('change', evt => evt.target.form.submit())
    );
});
